module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_null.6e76ae7c.png";